export default {
  locale: {
    en: 'Englisch',
    de: 'Deutsch',
  },
  app: {
    title: 'Vue Example App',
  },
};



// WEBPACK FOOTER //
// ./src/i18n/de.ts